import JwtService from "@/core/services/JwtService";
import store from "@/store";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/welcome",
    // redirect: "/dashboard",
    component: () => import("@/layouts/main-layout/MainLayout.vue"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
        meta: {
          pageTitle: "Dashboard",
          breadcrumbs: ["Dashboards"],
        },
      },
      {
        path: "/welcome",
        name: "welcome",
        component: () => import("@/views/WellcomePage.vue"),
        meta: {
          pageTitle: "Welcome",
          breadcrumbs: ["Getting Started"],
        },
      },
      {
        path: "/app_privacy_policy",
        name: "app_privacy_policy",
        component: () => import("@/views/PrivacyPolicy.vue"),
        meta: {
          pageTitle: "Privacy Policy",
          breadcrumbs: ["Policy"],
        },
      },
      {
        path: "/work-history",
        name: "work-history",
        component: () => import("@/views/reports/WorkHistory.vue"),
        meta: {
          pageTitle: "Driver Work History",
          breadcrumbs: ["Work History"],
        },
      },
      {
        path: "/work-history-list",
        name: "work-history-list",
        component: () => import("@/views/reports/WorkHistoryTable.vue"),
        meta: {
          pageTitle: "Driver Work History List",
          breadcrumbs: ["Work History List"],
        },
      },
      {
        path: "/work-rest-change",
        name: "work-rest-change",
        component: () =>
          import("@/views/reports/WorkRestChange/WorkRestChanges.vue"),
        meta: {
          pageTitle: "Work and Rest Change",
          breadcrumbs: ["Work and Rest History"],
        },
      },
      {
        path: "/non_compliance",
        name: "non_compliance",
        component: () =>
          import("@/views/reports/InvestigationAid/NonComplianceListing.vue"),
        meta: {
          pageTitle: "Investigation Aid",
          breadcrumbs: ["Investigation Aid"],
        },
      },
      {
        path: "/officer_annotation",
        name: "officer_annotation",
        component: () =>
          import(
            "@/views/reports/OfficerAnnotation/OfficerAnnotationListing.vue"
          ),
        meta: {
          pageTitle: "Officer Annotation",
          breadcrumbs: ["Officer Annotation"],
        },
      },
      {
        path: "/driver_comment",
        name: "driver_comment",
        component: () =>
          import("@/views/reports/DriverComment/DriverCommentListing.vue"),
        meta: {
          pageTitle: "Driver Comment",
          breadcrumbs: ["Driver Comment"],
        },
      },
      {
        path: "/builder",
        name: "builder",
        component: () => import("@/views/LayoutBuilder.vue"),
        meta: {
          pageTitle: "Layout Builder",
          breadcrumbs: ["Layout"],
        },
      },
      {
        path: "/crafted/pages/profile",
        name: "profile",
        component: () => import("@/components/page-layouts/Profile.vue"),
        meta: {
          breadcrumbs: ["Pages", "Profile"],
        },
        children: [
          {
            path: "/account",
            name: "account",
            component: () => import("@/views/crafted/account/Settings.vue"),
            meta: {
              pageTitle: "Account Information",
            },
          },
          {
            path: "/profile/non_compliance",
            name: "Investigation Aid Report",
            component: () => import("@/views/profiles/NonCompliance.vue"),
            meta: {
              pageTitle: "Investigation Aid Report",
            },
          },
          {
            path: "/profile/officer_annotation",
            name: "Officer Annotation Report",
            component: () => import("@/views/profiles/OfficerAnnotation.vue"),
            meta: {
              pageTitle: "Officer Annotation Report",
            },
          },
          {
            path: "/profile/driver_comment",
            name: "Driver Comment Report",
            component: () => import("@/views/profiles/DriverComment.vue"),
            meta: {
              pageTitle: "Driver Comment Report",
            },
          },
          {
            path: "/profile/work_history",
            name: "Work History Report",
            component: () => import("@/views/profiles/WorkHistory.vue"),
            meta: {
              pageTitle: "Work History Report",
            },
          },
        ],
      },
      {
        path: "/management/users/users-listing",
        name: "management-users-listing",
        component: () => import("@/views/management/users/UsersListing.vue"),
        meta: {
          pageTitle: "Users Listing",
          breadcrumbs: ["Management", "Users"],
        },
      },
      {
        path: "/user/detail/:id",
        name: "user-detail",
        component: () => import("@/views/management/users/UserDetail.vue"),
        meta: {
          pageTitle: "User Detail",
          breadcrumbs: ["User", "Detail"],
        },
      },
      {
        path: "/management/companies/companies-listing",
        name: "management-companies-listing",
        component: () =>
          import("@/views/management/companies/CompaniesListing.vue"),
        meta: {
          pageTitle: "Company Listing",
          breadcrumbs: ["Management", "Companies"],
        },
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/layouts/AuthLayout.vue"),
    children: [
      {
        path: "/sign-in",
        name: "sign-in",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
      },
      {
        path: "/sign-up",
        name: "sign-up",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignUp.vue"),
      },
      {
        path: "/password-reset",
        name: "request-password-reset",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/PasswordReset.vue"),
      },
      {
        path: "/reset_password/:token",
        name: "reset_password",
        component: () =>
          import(
            "@/views/crafted/authentication/basic-flow/ResetPasswordToken.vue"
          ),
      },
    ],
  },
  {
    path: "/multi-step-sign-up",
    name: "multi-step-sign-up",
    component: () =>
      import("@/views/crafted/authentication/MultiStepSignUp.vue"),
  },
  {
    path: "/diary_work_report/:request_key/:step",
    name: "diary-work-history",
    component: () => import("@/views/reports/WorkHistoryReportSimple.vue"),
  },
  {
    path: "/app_privacy_policy",
    name: "app_privacy_policy",
    component: () => import("@/views/PrivacyPolicy.vue"),
  },
  {
    path: "/help_page",
    name: "help_page",
    component: () => import("@/views/HelpPage.vue"),
  },
  {
    path: "/contact_us",
    name: "contact_us",
    component: () => import("@/views/ContactUs.vue"),
  },
  {
    path: "/",
    component: () => import("@/layouts/SystemLayout.vue"),
    children: [
      {
        // the 404 route, when none of the above matches
        path: "/404",
        name: "404",
        component: () => import("@/views/crafted/authentication/Error404.vue"),
      },
      {
        path: "/500",
        name: "500",
        component: () => import("@/views/crafted/authentication/Error500.vue"),
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  // console.log("test");

  if (to.path === "/sign-in") {
    const userToken = JwtService.getToken();
    if (userToken) {
      console.log("test");
      next("/");
    } else {
      console.log("test2");
      next();
    }
  } else {
    next();
  }
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  store.dispatch(Actions.VERIFY_AUTH, { api_token: JwtService.getToken() });

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
